var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrueArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.28571C17.7124 1.28571 20.364 2.09004 22.6193 3.59699C24.8746 5.10393 26.6324 7.24581 27.6704 9.75177C28.7084 12.2577 28.9799 15.0152 28.4508 17.6755C27.9216 20.3358 26.6154 22.7795 24.6975 24.6975C22.7795 26.6154 20.3358 27.9216 17.6755 28.4508C15.0152 28.9799 12.2577 28.7083 9.75178 27.6703C7.24582 26.6323 5.10394 24.8745 3.59699 22.6192C2.09005 20.3639 1.28572 17.7124 1.28572 15C1.28969 11.364 2.73586 7.87799 5.30693 5.30692C7.87799 2.73585 11.364 1.28968 15 1.28571ZM15 0C12.0333 0 9.13319 0.879734 6.66645 2.52796C4.19972 4.17618 2.27713 6.51886 1.14181 9.25975C0.00649922 12.0006 -0.290551 15.0166 0.288228 17.9264C0.867006 20.8361 2.29562 23.5088 4.3934 25.6066C6.49119 27.7044 9.16394 29.133 12.0737 29.7118C14.9834 30.2906 17.9994 29.9935 20.7403 28.8582C23.4811 27.7229 25.8238 25.8003 27.472 23.3335C29.1203 20.8668 30 17.9667 30 15C30 11.0218 28.4197 7.20644 25.6066 4.3934C22.7936 1.58035 18.9783 0 15 0Z",
    fill: "#0FB515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8871 10.9585L11.4943 24.3514L4.60715 17.4642L7.63715 14.4342L11.4943 18.2914L21.8571 7.92853L24.8871 10.9585Z",
    fill: "#0FB515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4943 24.5036L4.45499 17.4643L7.63713 14.2821L11.4943 18.1393L21.8571 7.77643L25.0393 10.9586L11.4943 24.5036ZM4.75927 17.4643L11.4943 24.1993L24.735 10.9586L21.8571 8.08071L11.4943 18.4436L7.63713 14.5864L4.75927 17.4643Z",
    fill: "#0FB515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9635 10.8831L24.812 11.0346L24.8892 11.1119L25.0408410.9604L24.9635 10.8831Z",
    fill: "#0FB515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrueArrow);
export default __webpack_public_path__ + "static/media/TrueArrow.baae17189a43e932e6f6724cfebac3c0.svg";
export { ForwardRef as ReactComponent };